import { render, staticRenderFns } from "./TelemetrySoftwareStatusModal.vue?vue&type=template&id=8a1e972a"
import script from "./TelemetrySoftwareStatusModal.vue?vue&type=script&lang=js"
export * from "./TelemetrySoftwareStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports